@if (loading) {
    <div
        class="agpr-loadingOverlay"
        [agprLoading]="loading"
    ></div>
}
@let isCanvas = briefingType === briefingDeliveryMethodEnum.ONLINE;
<div
    role="tabpanel"
    [id]="`${id}_tabPanel`"
    [attr.aria-labelledby]="id"
    [style.display]="selected ? '' : 'none'"
>
    @if (isCanvas) {
        <div [style.margin-top]="'-25px'">
            <!-- Just to fix the spacing when tabHeader is empty -->
        </div>
        <!-- TODO: This part will be finished in NEP-33012 -->
        <!-- <agpr-panel
            class="agpr-emailRecipientSearchTab-sendNotification"
            header="Briefing.sendNotification"
        >
            <agpr-button
                [id]="`${id}_sendNotification`"
                class="agpr-emailRecipientSearchTab-sendNotificationButton"
                icon="fa-regular fa-duotone fa-envelope"
                [style]="buttonTypes.icon"
                (click)="openSendNotificationDialog()"
            ></agpr-button>
        </agpr-panel> -->
        <agpr-panel
            class="agpr-emailRecipientSearchTab-notificationRecipients"
            header="Briefing.notificationRecipients"
        >
            <agpr-email-recipient-toolbar
                class="agpr-emailRecipientSearchTab-toolbar"
            ></agpr-email-recipient-toolbar>
            <ng-container *ngTemplateOutlet="recipientList"></ng-container>
        </agpr-panel>
    } @else {
        <ng-container *ngTemplateOutlet="recipientList"></ng-container>
    }
</div>

<ng-template #tabHeader>
    @if (!isCanvas) {
        <agpr-email-recipient-toolbar></agpr-email-recipient-toolbar>
    }
</ng-template>

<ng-template #recipientList>
    @if (!loading) {
        @if (recipients?.length > 0) {
            <ul>
                @for (recipient of recipients; track recipient) {
                    <li>
                        <agpr-email-recipient-card
                            [recipient]="recipient"
                        ></agpr-email-recipient-card>
                    </li>
                }
            </ul>
        } @else {
            <agpr-message
                [severity]="messageSeverityEnum.noContent"
                [useWhiteBg]="true"
            >
                <span>
                    {{ 'Briefings.recipients.noContent' | localize }}
                </span>
            </agpr-message>
        }
    }
</ng-template>


